import { ToastService } from 'src/app/services/toast.service';
import { ContenidoStatus } from './../../../../../common/contenido';
import { RevistaPageRequested, RevistaActionTypes, RevistaPageCancelled, RevistaPageLoaded, RevistaPageRight } from './revista.actions';
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, Action } from '@ngrx/store';
import { withLatestFrom, mergeMap, catchError, map, switchMap } from 'rxjs/operators';
import { ContenidoService } from '../../services/contenido.service';
import { revistaNextPageNum, revistaPageSize, revistaStatus } from './revista.selectors';
import { AppState } from 'src/app/reducers';
import { of, Observable } from 'rxjs';

@Injectable()
export class RevistaEffects {

	loadRevista$ = createEffect( () =>{
		return this.actions$.pipe(
			ofType<RevistaPageRequested>( RevistaActionTypes.RevistaPageRequested ),
			switchMap( action => {
				return this.service.findRevistaStatus().pipe(
						map( remoteStatus => {
							return { action, remoteStatus };
						}),
						catchError( error => of( { action, remoteStatus: null } ) )
					);
			}),
			withLatestFrom( this.store.select( revistaStatus ), this.store.select( revistaNextPageNum ), this.store.select( revistaPageSize ) ),
			mergeMap( ([ data, localStatus, nextPageNum, pageSize ]) => {
				let resultAction: Observable<Action>;
				let check: boolean = data["action"]["payload"]["check"];
				let remoteStatus: ContenidoStatus = data["remoteStatus"];
				let cleared: boolean = false;
				let status: ContenidoStatus = localStatus == null? remoteStatus: localStatus;

				if( remoteStatus == null ) {
					resultAction = of( new RevistaPageCancelled( { status: null } ) );
					this.toastService.danger( "No se pudo obtener el estado de las revistas" );
				} else {
					// Hay actualizaciones nuevas?
					if( localStatus != null && localStatus.lastUpdate != null && localStatus.qty != null &&
							( localStatus.lastUpdate.getTime() != remoteStatus.lastUpdate.getTime() || localStatus.qty != remoteStatus.qty ) ) {
						status = remoteStatus;
						nextPageNum = 0;
						cleared = true;
					}

					if( cleared || !check ) {
						resultAction = this.service.findRevistaByPage( { pageNum: nextPageNum, pageSize } )
							.pipe(
								map( revista => {
									++nextPageNum;
									return revista.length == 0?
										new RevistaPageCancelled( { status } ):
										new RevistaPageLoaded( { cleared, status, nextPageNum, revista } );
								}),
								catchError( error => {
									this.toastService.danger( "No se pudieron obtener revistas" );
									return of( new RevistaPageCancelled( { status } ) );
								})
							);
					} else
						resultAction = of( new RevistaPageRight() );
				}

				return resultAction;
			})
		);
	});

	constructor( private actions$: Actions, private store: Store<AppState>, private service: ContenidoService, private toastService: ToastService ) {
	}

}